import 'reflect-metadata';
import '@openfin/desktop-ui/ui-styles.css';

import {isDevelopmentEnv} from './utils/processHelpers';
import {mainReadyPromise} from './main';

// Render the window as soon as the DOM is ready.
document.addEventListener('DOMContentLoaded', async () => {
    if (isDevelopmentEnv()) {
        const finWindow = fin.Window.getCurrentSync();
        finWindow.updateOptions({contextMenu: true});
        finWindow.showDeveloperTools();
    }
    // Wait for the MVC entry point to initialize
    await mainReadyPromise();
});
